import React from 'react';
import {Box, Typography} from '@mui/material';
import translate from '@/utils/translate';
import styles from './BrandedContentEmptyResult.module.scss';

interface BrandedContentEmptyResultProps {
  testID?: string;
}

function BrandedContentEmptyResult({
  testID = 'branded-content-empty-result',
}: BrandedContentEmptyResultProps) {
  return (
    <Box className={styles.container} data-testid={testID}>
      <Box className={styles.header}>
        <Typography variant="h4" data-testid={`${testID}-title`}>
          {translate('Welcome to your Branded Content manager.')}
        </Typography>
        <Typography variant="h6" data-testid={`${testID}-description`}>
          {translate('View Instagram Partnership Ads permissions.')}
        </Typography>
      </Box>
      <Box className={styles.contentContainer}>
        <Box component="section" className={styles.manageSection}>
          <Typography variant="h6">{translate('Manage Creators')}</Typography>
          <Typography variant="body1">
            {translate(
              'Once you have requested branded content ads permissions from a creator, they will show up here along with the status of that request.'
            )}
          </Typography>
        </Box>
        <Box component="section" className={styles.requestSection}>
          <Typography variant="h6">
            {translate('Request Permissions')}
          </Typography>
          <Typography variant="body1">
            {translate(
              'You can request branded content ads permissions from creators that are participating in your Content Creation, Instagram, and Facebook campaigns.'
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default BrandedContentEmptyResult;
